import HasLabel from "@/models/HasLabel";
import { Prescription } from "@/models/Prescription";

export interface TIPartnerPharmacy {
    id: number;
    name: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    pharmacistInCharge: string;
    licenseNumber: string;

}

export interface InterchangeNote {
    id: number,
    originalScriptId: number,
    note: string,
    created: Date,
    createdBy: Date
}

export class TIInterchange {
    prescriptions!: Prescription[];
    creationNote!: string;
    partnerPharmacyId!: number;
}

export class TIPartnerPharmacy extends HasLabel {
    toString(): string {
        if (this.name)
            return ('Name: ' + this.name + ', Address: ' + this.address1 + ', ' + (this.address2 ? ', ' + this.address2 : '') + this.city + ', ' + this.state + ', ' + this.zip + ', PIC: ' + this.pharmacistInCharge + ', License #: ' + this.licenseNumber);
        else return '';
    }
}
